(function () {
    'use strict';

    angular
        .module('admin')
        .controller('PartnerUserListController', PartnerUserListController);

    PartnerUserListController.$inject = ['$state', '$stateParams', '$timeout', '$uibModal', 'ManagePartnersService'];

    function PartnerUserListController($state, $stateParams, $timeout, $uibModal, ManagePartnersService) {
        var vm              = this;
        vm.getByFilter      = getByFilter;
        vm.deletePartner    = deletePartner;
        vm.editPartner      = editPartner;
        vm.sendPassword     = sendPassword;
        vm.flag             = false;
        vm.search           = '';

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = [];
        vm.currentPage  = null;
        vm.itemsPerPage = [];
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function activate() {
            vm.getByFilter();
        }

        function getByFilter () {
            vm.query            = {};
            vm.query['page']    = vm.page;
            vm.query['search']  = vm.search;
            vm.flag             = false;
            ManagePartnersService.getAdmPartnerUsers(vm.query).then(function(response){
                vm.partners = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);
                vm.to = response.data.to;
                if(vm.partners){
                    vm.flag = true;
                }
            }).catch(function(err) {
            });
        }

        function editPartner(partner){
            $uibModal.open({
                templateUrl: 'templates/partners/users/edit/form.html',
                controller: 'PartnerUserEditController',
                controllerAs:'vm',
                size: 'lg',
                resolve:
                    {
                        partner     : function () {
                            return partner;
                        }
                    }
            });
        }

        function deletePartner(partner){
            alertify
                .confirm('This action is not irreversible!')
                .set('labels', {
                    ok: 'Yes',
                    cancel: 'No'
                })
                .set('title', 'Do you really want to DELETE this partner user?')
                .set('onok', function (){
                    ManagePartnersService.deletePartnerUser(partner.id).then(function() {
                        delete vm.partners[partner.id];
                        vm.to = vm.to - 1;
                        vm.totalItems = vm.totalItems - 1;
                        vm.partners.splice(vm.partners.indexOf(partner), 1);
                        alertify.notify('Partner user deleted', 'success', 3);
                    });
                })
                .show();
        }

        function sendPassword(partner) {
            alertify
                .confirm('Send password for ' + partner.name)
                .set('labels', {
                    ok: 'Yes',
                    cancel: 'No'
                })
                .set('title', 'Send user password')
                .set('onok', function (){
                    ManagePartnersService.sendPassword(partner.id).then(function() {
                        alertify.notify('Partner user password successfull sended', 'success', 3);
                    });
                })
                .show();
        }
        activate();
    }

})();